
(() => {
  const MOBILE_QUERY = '(max-width: 900px)';
  const SECTION_SELECTOR = 'product-video-reels';
  const CARD_SELECTOR = '.wt-product-video-reels__item';

  const mediaQuery = window.matchMedia(MOBILE_QUERY);

  function initProductVideos() {
    const isMobile = mediaQuery.matches;

    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      const cards = section.querySelectorAll(CARD_SELECTOR);

      if (!isMobile) {
        section.querySelectorAll('.mobile-video-sound-toggle').forEach((button) => button.remove());

        cards.forEach((card) => {
          if (card._mobileVideoClickHandler) {
            card.removeEventListener('click', card._mobileVideoClickHandler, true);
            delete card._mobileVideoClickHandler;
          }

          const playIcon = card.querySelector('.wt-product-video-reels__play-icon');
          if (playIcon) playIcon.style.removeProperty('display');
        });

        section._mobileVideoObserver?.disconnect();
        delete section._mobileVideoObserver;
        delete section.dataset.mobileVideoInitialized;
        return;
      }

      if (section.dataset.mobileVideoInitialized === 'true') return;

      const template = document.querySelector('#video-reels-controls');
      const soundButton = template?.content.querySelector('.wt-video__sound-toggle');

      section.dataset.mobileVideoInitialized = 'true';

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const content = card.querySelector('.wt-product-video-reels__item__content') || card;
        const playIcon = card.querySelector('.wt-product-video-reels__play-icon');

        if (!video) return;

        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');

        if (playIcon) playIcon.style.setProperty('display', 'none', 'important');

        if (soundButton && !content.querySelector('.mobile-video-sound-toggle')) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mobile-video-sound-toggle';
          button.innerHTML = soundButton.innerHTML;
          button.dataset.sound = 'off';
          button.setAttribute('aria-label', 'Unmute video');

          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            video.muted = !video.muted;
            button.dataset.sound = video.muted ? 'off' : 'on';
            button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          });

          content.appendChild(button);
        }

        if (getComputedStyle(content).position === 'static') {
          content.style.position = 'relative';
        }

        if (!card._mobileVideoClickHandler) {
          card._mobileVideoClickHandler = (event) => {
            if (event.target.closest('.mobile-video-sound-toggle')) return;
            if (event.target.closest('a, button, input, select, textarea')) return;

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
          };

          card.addEventListener('click', card._mobileVideoClickHandler, true);
        }
      });

      if ('IntersectionObserver' in window) {
        section._mobileVideoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (!video) return;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.5, 1] });

        cards.forEach((card) => section._mobileVideoObserver.observe(card));
      } else {
        cards.forEach((card) => card.querySelector('video')?.play().catch(() => {}));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductVideos);
  } else {
    initProductVideos();
  }

  mediaQuery.addEventListener('change', initProductVideos);
  document.addEventListener('shopify:section:load', initProductVideos);
})();
